import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import ApiConfigModal from "./Components/ApiConfigModal";
import ReserveringssystemenTable from "./Components/ReserveringssystemenTable";
import ImportSection from "./Components/ImportSection";
import TommyArtikelenModal from "./Components/TommyArtikelenModal";
import { 
  fetchReserveringssystemen, 
  createReserveringssysteem, 
  updateReserveringssysteem,
  deleteReserveringssysteem,
  toggleActiveReserveringssysteem
} from "./Reducers/actions";
import { message as showMessage } from "../../../Reducers/loading/actions";

const ReserveringssystemenPage = ({ 
  reserveringssystemen, 
  loading, 
  error,
  fetchReserveringssystemen,
  createReserveringssysteem,
  updateReserveringssysteem,
  deleteReserveringssysteem,
  toggleActiveReserveringssysteem
}) => {
  const dispatch = useDispatch();
  const message = (time, type, msg) => dispatch(showMessage(time, type, msg));
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [selectedSystem, setSelectedSystem] = useState(null);
  const [importing, setImporting] = useState(false);
  const [showingTommyArtikelen, setShowingTommyArtikelen] = useState(false);
  const [tommyArtikelen, setTommyArtikelen] = useState([]);

  useEffect(() => {
    fetchReserveringssystemen();
  }, [fetchReserveringssystemen]);

  // Check of er categorieën beschikbaar zijn
  const checkCategoriesAvailable = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch("/api/admin/standplaatsen/categorien", {
        headers: { 
          "Authorization": token,
          "Content-Type": "application/json"
        }
      });
      const data = await response.json();
      // We don't need to store this in state anymore, just for the callback
      return data.results && data.results.length > 0;
    } catch (error) {
      console.error("Fout bij ophalen categorieën:", error);
      return false;
    }
  };

  const handleOpenModal = (item = null) => {
    setEditingItem(item);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setEditingItem(null);
    setIsModalOpen(false);
  };

  const handleSubmitConfig = async (values) => {
    try {
      // Maak een schone kopie van de form values zonder circulaire referenties
      const cleanData = {
        naam: values.naam || '',
        url: values.url || '',
        authMethod: values.authMethod || 'none',
        authConfig: values.authConfig ? {
          token: values.authConfig.token || '',
          username: values.authConfig.username || '',
          password: values.authConfig.password || '',
          keyName: values.authConfig.keyName || '',
          keyValue: values.authConfig.keyValue || ''
        } : {},
        headers: values.headers ? values.headers.map(h => ({
          name: h.name || '',
          value: h.value || ''
        })) : []
      };
      
      let result;
      if (editingItem && editingItem._id) {
        // Update bestaand reserveringssysteem
        result = await updateReserveringssysteem(editingItem._id, cleanData);
      } else {
        // Maak nieuw reserveringssysteem aan
        result = await createReserveringssysteem(cleanData);
      }
      
      if (result.type === "success") {
        setIsModalOpen(false);
        message(3000, "success", editingItem ? "Reserveringssysteem succesvol bijgewerkt!" : "Reserveringssysteem succesvol opgeslagen!");
        // Refresh de lijst
        fetchReserveringssystemen();
      } else {
        message(4000, "warning", "Fout bij opslaan: " + result.payload);
      }
    } catch (error) {
      message(4000, "warning", "Er is een fout opgetreden: " + error.message);
    }
  };

  const handleDelete = async (id, naam) => {
    if (window.confirm(`Weet je zeker dat je "${naam}" wilt verwijderen?`)) {
      try {
        const result = await deleteReserveringssysteem(id);
        if (result.type === "success") {
          message(3000, "success", "Reserveringssysteem succesvol verwijderd!");
        } else {
          message(4000, "warning", "Fout bij verwijderen: " + result.payload);
        }
      } catch (error) {
        message(4000, "warning", "Er is een fout opgetreden: " + error.message);
      }
    }
  };

  const handleToggleActive = async (id) => {
    try {
      const result = await toggleActiveReserveringssysteem(id);
      if (result.type !== "success") {
        message(4000, "warning", "Fout bij wijzigen status: " + result.payload);
      }
    } catch (error) {
      message(4000, "warning", "Er is een fout opgetreden: " + error.message);
    }
  };

  // Handler voor Tommy artikelen
  const handleTommyArtikelenFetched = (artikelen) => {
    setTommyArtikelen(artikelen);
    setShowingTommyArtikelen(true);
  };

  return (
    <div className="box box-default">
      <div className="box-header with-border">
        <h3 className="box-title">Reserveringssystemen</h3>
        <div className="box-tools pull-right">
          <button 
            type="button" 
            className="btn btn-primary btn-sm"
            onClick={handleOpenModal}
          >
            <i className="fa fa-plus"></i>&nbsp; API Koppeling Toevoegen
          </button>
        </div>
      </div>
      <div className="box-body">
        {loading && (
          <div className="text-center py-3">
            <i className="fas fa-spinner fa-spin"></i> Laden...
          </div>
        )}
        
        {error && (
          <div className="alert alert-danger">
            <i className="fas fa-exclamation-triangle"></i> {error}
          </div>
        )}
        
        {!loading && reserveringssystemen.length === 0 ? (
          <div className="text-center py-4">
            <i className="fas fa-plug fa-3x text-muted mb-3"></i>
            <h5 className="text-muted">Geen API koppelingen geconfigureerd</h5>
            <p className="text-muted">
              Voeg een API koppeling toe om te beginnen met reserveringssystemen integratie.
            </p>
            <button 
              type="button" 
              className="btn btn-primary"
              onClick={() => handleOpenModal()}
            >
              <i className="fa fa-plus me-2"></i>
              Eerste API Koppeling Toevoegen
            </button>
          </div>
        ) : !loading && reserveringssystemen.length > 0 && (
          <ReserveringssystemenTable 
            reserveringssystemen={reserveringssystemen}
            onEdit={handleOpenModal}
            onDelete={handleDelete}
            onToggleActive={handleToggleActive}
          />
        )}

        {/* Import sectie - alleen tonen als er reserveringssystemen zijn */}
        {!loading && reserveringssystemen.length > 0 && (
          <ImportSection 
            reserveringssystemen={reserveringssystemen}
            selectedSystem={selectedSystem}
            setSelectedSystem={setSelectedSystem}
            importing={importing}
            setImporting={setImporting}
            onTommyArtikelenFetched={handleTommyArtikelenFetched}
            checkCategoriesAvailable={checkCategoriesAvailable}
          />
        )}
      </div>

      <ApiConfigModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSubmit={handleSubmitConfig}
        initialValues={editingItem}
      />

      <TommyArtikelenModal 
        isOpen={showingTommyArtikelen}
        onClose={() => setShowingTommyArtikelen(false)}
        artikelen={tommyArtikelen}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  reserveringssystemen: state.reserveringssystemen.items,
  loading: state.reserveringssystemen.loading,
  error: state.reserveringssystemen.error
});

const mapDispatchToProps = {
  fetchReserveringssystemen,
  createReserveringssysteem,
  updateReserveringssysteem,
  deleteReserveringssysteem,
  toggleActiveReserveringssysteem
};

export default connect(mapStateToProps, mapDispatchToProps)(ReserveringssystemenPage);